import { render } from "./ProductsComponent.vue?vue&type=template&id=5b6b5aa6"
import script from "./ProductsComponent.vue?vue&type=script&lang=js"
export * from "./ProductsComponent.vue?vue&type=script&lang=js"

import "./ProductsComponent.vue?vue&type=style&index=0&id=5b6b5aa6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__